import React, { Fragment, useState, useEffect,useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DocumentView from 'components/sales/downloadDocView/documentView';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import ComplaintReply from 'components/sales/ListFilters/ComplaintReply';
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import FileUpload from "../../../components/sales/fileUpload/fileUpload";
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import { toast } from 'react-toastify';
import { formatDescription } from '../../../services/utils/helpers/customHelper';
import Config from "services/config/config";
import axios from 'axios';
import parse from 'html-react-parser';
import "./complain.css";

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const headers = ['Ticket ID', 'Assigned To', 'Created On', 'Status', 'Actions'];
const ViewComplain = ({
  complainRaisedTicket,
  closeComplain,
  reopenComplain,
  viewDetails,
  viewComplainDetails,
  saveComplaintReply,
  match,
  documentUploadUrlPublic,
  documentUrlDataPublic,
  getCategoryCX,
  setCategoryCX,
  fetchFaqs,
  closeDuplicateComplaint,
  duplicateComplainClosed = [],
  ticketCategories,
  updateComplainCategories,
  // categoryList,
  // l1List,
  // l2List,
  // l3List
}) => {
  const [listData, setListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [complainId, setComplainId] = useState(false);
  const [isConfirmation, setIsConfirmation] = useState(false);
  const [isClientMsg, setIsClientMsg] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isReply, setIsReply] = useState(false);
  const [duplicate, setDuplicate] = useState(false);
  const [editTicket, setEditTicket] = useState(false);
  const [duplicateTicket, setDuplicateTicket] = useState(null);
  const [editData, setEditData] = useState('');
  const [IsEditModal, setIsEditModal] = useState(false);
  
  
  const [category, setCategory] = useState(false);
  const [categoryData, setCategoryData] = useState({complainId: parseInt(match.params.id),category:null,l1:null,l2:null,l3:0});
  const [l1,setL1] = useState("");
  const [isSuccessFor, setIsSuccessFor] = useState('');
  const [ticketData, setTicketData] = useState('');
  const [status, setStatus] = useState('');
  const [internalStatus, setInternalStatus] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const compId = { complain_id: complainId };
  const [closeData, setCloseData] = useState({attachment_file:'',remark:''});
  const [replyData, setReplyData] = useState({attachment_file:[],message:'',send_to:'1',attachment_mand:false});
  const [isModal, setIsModal] = useState(false);
  const [categoryList, setCategoryList] = useState([]);
  const [l1List, setL1List] = useState([]);
  const [l2List, setL2List] = useState([]);
  const [l3List, setL3List] = useState([]);
  const [cross, setCross] = useState(false);
  const [duplicateCard, setDuplicateCard] = useState(false);
  const [duplicateComplainIds, setDuplicateComplainIds] = useState(false);
  const [complainIdsDropdown, setComplainIdsDropdown] = useState([]);
  const [complainIdValue, setComplainIdValue] = useState([]);
  const [markSucessModal, setMarkSucessModal] = useState(false);
  const [formData, setFormData] = useState({ category: "", subcategory: "" });
  const [ComplaincategoryList, setComplainCategoryList] = useState([]);
  const [subcategory, setSubcategory] = useState([]);

  const handleIsConfirmation = () => {
    setIsConfirmation(!isConfirmation);
  };

  const handleIsClientMsg = () => {
    setIsClientMsg(!isClientMsg);
  };

  const handleDuplicateModal = () => {
    setDuplicateComplainIds(!duplicateComplainIds)
  }
  
  const handleIsSuccess = () => {
    setIsSuccess(!isSuccess);
  };
  const handleIsReply = () => {
    setIsReply(!isReply);
  };
  
  const handleDuplicate = () => {
    setDuplicate(!duplicate);
    setCross(true);
  };
  // handleEditTicket
  const handleEditTicket = () => {
    setEditTicket(!editTicket);

  };
  const filterToggle = () => {
    setShowFilter(!showFilter);
};

const handleMarkModalHide = () => setMarkSucessModal(false);
const handleEditModalHide = () => setIsEditModal(false);

  const handleRaiseTicket = async () => {
    setIsLoading(true);
    await complainRaisedTicket(compId);
    await viewDetails(match.params.id);
    setIsLoading(false);
    setIsSuccessFor(localization.raiseTicket);
    handleIsSuccess();
  };
  const handleCloseComplain = async () => {
    if(closeData?.remark && closeData?.remark !=""){
      var data = {
        complain_id : compId?.complain_id,
        attachment_file : closeData?.attachment_file,
        remark : closeData?.remark,
      };
      await closeComplain(data);
      setIsLoading(true);
      await viewDetails(match.params.id);
      setIsLoading(false);
      setIsSuccessFor(localization.closeComplain);
      handleIsConfirmation();
      handleIsSuccess();
    }else{
      setErrorMessage('Please Enter Remark');
    }
    
  };

  const handleComplainDropdown = () => {
    setComplainIdsDropdown(ticketData?.complain_ids_dropdown)
  }

  const handleMsgSubmit = async () => {
    setIsLoading(true);
    // setFilterData(filterData);
    var datacheck = await saveComplaintReply(replyData,match.params.id,true);
    if(datacheck){
      setIsReply(true);
      await viewDetails(match.params.id);
    }
    setIsLoading(false);
    setReplyData({attachment_file:[],message:'',send_to:'1',attachment_mand:false});
    setIsClientMsg(false);
  }

  const handleMarkSubmit = async () => {
    setIsLoading(true);
    var datacheck = await closeDuplicateComplaint(match?.params?.id, complainIdValue);
    if(datacheck){
      setMarkSucessModal(true);
    }
    setIsLoading(false);
  }

  const handleReopen = (val) => {
    if(val){
      (async () => {
        await reopenComplain(compId);
        setIsLoading(true);
        await viewDetails(match.params.id);
        setIsLoading(false);
        setIsSuccessFor(localization.closeComplain);
        handleIsSuccess();
      })();
    }
  }
  useEffect(()=>{
    (async () => {
      setCategoryList(await getCategoryCX("category"));
    })();
  },[])

  useEffect(() => {
    const fetchTicketCategories = async () => {
      try {
        const res = await ticketCategories();
        const formattedCategories = res.category_data.map((item) => ({
          id: item.id,
          name: item.description,
        }));
        setComplainCategoryList(formattedCategories);
      } catch (error) {
        setComplainCategoryList([]);
      }
    };

    fetchTicketCategories();
  }, []);

 useEffect(() => {
  const fetchSubCategory = async () => {
    if (!formData.category) {
      setSubcategory([]);
      return;
    }

    try {
      const subcatData = await fetchFaqs(formData.category);

      const formattedData = subcatData.map((item) => ({
        id: item.id,
        name: item.question,
      }));

      setSubcategory(formattedData);
    } catch (err) {
      setSubcategory([]);
    }
  };

  fetchSubCategory();
}, [formData.category, fetchFaqs]);


  const handleInputValueChange = async (categoryType, category, l1=null, l2=null) => {
        if(l1==null)
          setL1List(await getCategoryCX(categoryType, category, l1, l2));
        else if(l2 == null)
          setL2List(await getCategoryCX(categoryType, category, l1, l2));
        else
          setL3List(await getCategoryCX(categoryType, category, l1, l2));
  }

  const handleSaveCategory = () => {
    if(categoryData.complainId=='' || categoryData.category=='' || categoryData.l1=='' || categoryData.l2==''){
      toast.error("Select all required fields for categories")
      return;
    }
    else {
      (async () => {
        setIsLoading(true);
        const res = await setCategoryCX(categoryData);
        setIsLoading(false);
        if (res) {
          setCategory(false);
          setIsModal(true);
        } else {
          toast.error('Select category and sub-categories!');
          return;
        }
      })();
    }
  }
  
const headerBtns = () => {
  return (
    <Fragment>
      <Button
        className="btn btn-primary d-md-inline-block me-2 px-3"
        onClick={()=>{setIsEditModal(true)}}
      >
        Update {localization.insightsCategory}
      </Button>
      <Link
        to={`/dashboard/complaint-log/${match.params.id}`}
        className="btn btn-primary d-none d-md-inline-block me-2 px-4"
      >
        Log
      </Link>
      {status.toUpperCase() !== 'CLOSED' && (
        <>

          <Button
            className="btn btn-primary d-none d-md-inline-block me-2 px-3"
            onClick={()=>{setCategory(true)}}
          >
            Select CX Category
          </Button>

          <Button
            className="btn btn-primary d-none d-md-inline-block me-2 px-3"
            onClick={handleIsConfirmation}
          >
            {localization.closeComplain}
          </Button>
          {cross && ticketData?.complain_ids_dropdown && (
            <Button
              className="btn btn-primary d-none d-md-inline-block me-2 px-3"
              onClick={() => {
                handleDuplicateModal(true)
                handleComplainDropdown()
              }}
            >
              Mark as Duplicate
            </Button>
          )}
          <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
          >
            <img src={Images?.SelectMenu} alt=""/>
            <b className="site_filters" style={{width: "max-content"}}>
                {`Assign Ticket`}
            </b>
          </Button>
        </>
        )}
        {/* {status.toUpperCase() === 'OPEN' &&
          ticketData?.troubleshoot.length === 0 && (
            <Link
              to={`/dashboard/complains/troubleshoot/${match.params.id}`}
              className="btn btn-primary d-none d-md-inline-block"
            >
              {localization.troubleshoot}{' '}
              <img src={Images?.ArrowRight} alt="" />
            </Link>
          )} */}
          {/* {status.toUpperCase() === 'CLOSED' && (
          <Button
            className="btn btn-transparent d-none d-md-inline-block"
            onClick={() => handleReopen(true)}
          >
            {localization.reopenComplain}
          </Button>
        )} */}
        {/* <Button
            onClick={filterToggle}
            className="filter-hamburger btn btn-transparent filter-btn-dir filters_direction filters-section"
        >
            <img src={Images?.SelectMenu} alt=""/>
            <b className="site_filters" style={{width: "max-content"}}>
                {`Reply`}
            </b>
        </Button> */}
      </Fragment>
    );
  };
  useEffect(() => {
    setComplainId(match.params.id);
  }, [match]);
  useEffect(() => {
    if (viewComplainDetails !== null) {
     
      if(viewComplainDetails.duplicate_complain_id.length > 0) {
        setDuplicate(true);
      }else{
        setDuplicate(false);
      }
      setDuplicateTicket(viewComplainDetails.duplicate_complain_id);
      setTicketData(viewComplainDetails);
      setStatus(viewComplainDetails.status);
      setInternalStatus(viewComplainDetails.internal_status);
      const tableData = ['id', 'assigned_to', 'created_at', 'status'];
      if (viewComplainDetails && viewComplainDetails.rm_ticket) {
        const data = viewComplainDetails.rm_ticket.map((element) =>
          Object.assign(
            {},
            ...tableData.map((key) => ({ [key]: element[key] })),
            {
              Actions: {
                name: 'View Details',
                link: `/dashboard/rm-view/${element.id}`,
              },
            }
          )
        );
        setListData(data);
      }
    }
  }, [viewComplainDetails]);
useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewDetails(match.params.id);
      setIsLoading(false);
    })();
  }, [viewDetails, match.params.id]);
  const successIconBox = (text) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          {isSuccessFor === localization.raiseTicket
            ? localization.ticketSuccessfullyCreated
            : localization.complainClosedSuccessfully}
        </h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.continue} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const applyFilter = async (filterData) => {
    //console.log(JSON.stringify(filterData)); return false;
    // localStorage.setItem("complaintReply", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    var datacheck = await saveComplaintReply(filterData,match.params.id,false);
    if(datacheck){
      setIsReply(true);
      await viewDetails(match.params.id);
    }
    setIsLoading(false);
    filterToggle();
};

const handleUpdate = async () => {
  try {
    setIsLoading(true);
    const payload = {
      complainId: ticketData?.id,
      category: formData?.category,
      subcategory: formData?.subcategory,
    };

    const res = await updateComplainCategories(payload);
    setIsLoading(false);
    if (res === true) {
      toast.success("Category updated successfully!");
      setIsEditModal(false);
      setTimeout(() => {
          window.location.reload();
        }, 800);
    }

  } catch (error) {
    setIsLoading(false);
    toast.error("Failed to update category.");
  }
};

  return (
    <Fragment>
      <Layout
        title={localization.viewComplain}
        Buttons={headerBtns}
        isLoading={isLoading}
        isGoback
        linkFlag
        linkUrl={'/dashboard/complains-list'}
      >
        <PanelCardWithHeading 
          title={localization.complainDetails} 
          status={ticketData?.internal_status}
        >
          <div className="details-listing">
            <DivLayout heading={localization.complainId} data={ticketData.id} />
            <DivLayout
              heading={localization.siteNumber}
              data={ticketData.site_no}
            />
            <DivLayout
              heading={localization.siteName}
              data={ticketData.site_name}
            />
            <DivLayout
              heading={localization.projectId}
              data={cell(ticketData.infra_project_id)}
            />
            {/* {ticketData?.channel_partner_id && (
            <DivLayout
              heading={'Channel Partner ID'}
              data={ticketData?.channel_partner_id}
            />
            )} */}
            <DivLayout
              heading={localization.complainRaisedBy}
              data={ticketData.complain_raised_by}
            />
            <DivLayout
              heading={localization.complainType}
              data={ticketData.complain_type}
            />
            <DivLayout heading={localization.gate} data={ticketData.gate} />
            <DivLayout heading={localization.amc} data={ticketData?.amc} />
            <DivLayout
              heading={localization.product}
              data={ticketData.product}
            />
            <DivLayout
              heading={localization.materialRequired}
              data={ticketData.material_required}
            />
            {ticketData.complain_faqs_question!=null && <> 
            <DivLayout
              heading="Insight Category"
              data={ticketData.category_description}
            />
            <DivLayout
              heading="Question"
              data={`${ticketData.complain_faqs_question} [${ticketData.complain_priority}]`}
            />
            </>}
            <DivLayout
              heading="Is Internet present"
              data={ticketData.is_internet}
            />
            <DivLayout
              heading="Call to client"
              data={ticketData.call_client}
            />
{/*             
            <DivLayout
              heading={localization.cDescription}
              data={parse(ticketData.complain_description)}
            /> */}
            {/* <DivLayout
              heading={localization.description}
              data={ticketData.document}
            /> */}
            <DivLayout
              heading={localization.createdOn}
              data={moment(ticketData.created_at, 'DD-MM-YYYY HH:mm:ss').format(
                'DD-MM-YYYY HH:mma'
              )}
            />
            <DivLayout
              heading={localization.nameOfSpoc}
              data={ticketData.name_of_spoc}
            />
            <DivLayout
              heading={localization.numberOfPoc}
              data={ticketData.number_of_poc}
            />
            {/* <DivLayout
              heading={localization.status}
              data={ticketData.status}
              status
            /> */}
            {ticketData.cx_category_category!="" && <> 
            <DivLayout
              heading="CX Category"
              data={ticketData.cx_category_category}
            />
            </>}
            {ticketData.cx_category_category!="" && <> 
            <DivLayout
              heading="CX Sub Category L1"
              data={ticketData.cx_category_l1}
            />
            <DivLayout
              heading="CX Sub category L2"
              data={ticketData.cx_category_l2}
            />
            {ticketData.cx_category_l3!=0 && 
            <DivLayout
              heading="CX Sub category L3"
              data={ticketData.cx_category_l3}
            />}</>}
            {ticketData.document && (ticketData.document.map((document) => (
              document ? 
                <DocumentView attachment={document} />
                :
                null
            )))}

          

            {ticketData &&
              ticketData?.troubleshoot &&
              Object.keys(ticketData?.troubleshoot).length > 0 && (
                <Fragment>
                  <h5 className="full-width">{localization.troubleshoot}</h5>
                  <div className="form-group">
                    <div className="details-listing faq-listing">
                      {ticketData.troubleshoot &&
                        ticketData.troubleshoot.questions &&
                        ticketData.troubleshoot.questions.length &&
                        ticketData.troubleshoot.questions.map((obj) => {
                          return (
                            <div className="details-list question-input">
                              <label className="data-title">
                                {obj.question}
                              </label>
                              {obj.answers.length &&
                                obj.answers.map((ele, ind) => {
                                  return (
                                    <div className="sub-question" key={ind}>
                                      <label className="label">
                                        {ele.label}
                                      </label>
                                      <label className="label">
                                        {ele.answer}
                                      </label>
                                    </div>
                                  );
                                })}
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </Fragment>
              )}
          </div>
          {ticketData?.complain_description && (
            <div>
              {formatDescription(ticketData.complain_description)}
            </div>
          )}

          
          {status.toUpperCase() !== 'CLOSED' && (
            <div className="form-group full-width">
              {/* <Button
                className="btn btn-primary d-none d-md-inline-block"
                onClick={handleRaiseTicket}
              >
                {localization.raiseTicket}{' '}
                <img src={Images?.ArrowRight} alt="" />
              </Button> */}
            </div>
          )}
        </PanelCardWithHeading>

        {ticketData &&
          ticketData.channel_partner_id &&
          ticketData.three_poc &&
          ticketData.three_poc.map((messageDatas, index) => ( 

              <PanelCardWithHeading 
                  title={`Channel Partner ${index + 1}: (${ticketData.channel_partner_id})`} 
              >
                  <div className="details-listing">
                      <DivLayout heading="Name" data={messageDatas.name} />
                      <DivLayout heading="Mobile Number" data={messageDatas.contact_no} />
                      <DivLayout heading="Email" data={messageDatas.email} />
                  </div>
              </PanelCardWithHeading>
        ))}



{/* {duplicateCard && (`
  ticketData?.duplicate_data.map((data, index) => (
    <PanelCardWithHeading 
      key={index} 
      title={localization.complainDetails} 
      status={data?.internal_status}
    >
      <div className="details-listing">
        <DivLayout heading={localization.complainId} data={data?.id} />
        <DivLayout heading={localization.complainRaisedBy} data={data?.complain_raised_by} />
        <DivLayout heading={localization.complainType} data={data?.complain_type} />
        <DivLayout 
          heading={localization.createdOn} 
          data={moment(data?.created_at, 'DD-MM-YYYY HH:mm:ss').format('DD-MM-YYYY HH:mma')} 
        />
        <DivLayout heading={localization.nameOfSpoc} data={data?.name_of_spoc} />
        <DivLayout heading={localization.numberOfPoc} data={data?.number_of_poc} />

        {data.cx_category_category !== "" && (
          <>
            <DivLayout heading="Category" data={data?.cx_category_category} />
            <DivLayout heading="Sub-category L1" data={data?.cx_category_l1} />
            <DivLayout heading="Sub-category L2" data={data?.cx_category_l2} />
            {data?.cx_category_l3 !== 0 && (
              <DivLayout heading="Sub-category L3" data={data?.cx_category_l3} />
            )}
          </>
        )}

        {data?.document && data?.document.map((document, docIndex) => (
          document ? <DocumentView key={docIndex} attachment={document} /> : null
        ))}
      </div>
      {(data?.complain_description)?
            parse(data?.complain_description)
          :null
          }
    </PanelCardWithHeading>
  ))
)} */}

        

        <a onClick={handleIsClientMsg} class="float">
          <span class="my-float">
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" style={{'top' : '1.2rem','position': 'relative'}} class="bi bi-envelope" viewBox="0 0 16 16">
              <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1H2Zm13 2.383-4.708 2.825L15 11.105V5.383Zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741ZM1 11.105l4.708-2.897L1 5.383v5.722Z"/>
            </svg>
          </span>
         
        </a>

            {/* Messages start */}
            
      {ticketData &&
        ticketData?.messageData &&
        ticketData.messageData.map((messageDatas) => ( 

            <PanelCardWithHeading title={`Replied By : `+messageDatas.message_from+` ( ` +messageDatas.created_at+ ` )`} colorChange={messageDatas.message_from == 'Client' && '#fff3f3'}>
              <div className="details-listing">
                <DivLayout heading={`Send To`} data={messageDatas.send_to} />
                {messageDatas.rm_ticket_id !== null && messageDatas.rm_ticket_id !='' ? (  
                  <DivLayout
                    heading={`Ticket Id`}
                    data={messageDatas.rm_ticket_id}
                  />
                ): 
                  <DivLayout
                    heading={`Created By`}
                    data={(messageDatas?.name !== null) ? messageDatas?.name : 'Client'}
                  />
                }
                {messageDatas?.document && (messageDatas.document.map((documentss, ind) => (
                  <DocumentView title={`${localization.attachment} ${
                    ind + 1
                  }`} attachment={documentss} />
                )))}
                <DivLayout
                  heading={`Message`}
                  data={messageDatas.message}
                  lcx={true}
                />
                {messageDatas.rca !== null && 
                <DivLayout
                  heading={`RCA`}
                  data={messageDatas.rca}
                />
                }
                {messageDatas.issue_name !== null && messageDatas.issue_name != '' && (
                  <DivLayout
                    heading={`Issue Type`}
                    data={messageDatas.issue_name}
                  />
                )}

                {messageDatas.sub_issue_name !== null && messageDatas.sub_issue_name != '' && (
                  <DivLayout
                    heading={`Sub-issue Type`}
                    data={messageDatas.sub_issue_name}
                  />
                )}

                {messageDatas?.rm_ticket ? 
                <table className='panel-table table table-striped table-bordered'>
                  <thead>
                    <th>Assigned To</th>
                    <th>Status</th>
                    <th>Action</th>
                  </thead>
                  <tbody>
                  {messageDatas.rm_ticket && (messageDatas.rm_ticket.map((rmData) => (
                    
                      <tr>
                        <td>{rmData.assigned_to}</td>
                        <td>{rmData.status}</td>
                        <td><a class="btn btn-transparent" href={`/dashboard/rm-view/`+rmData.id}>View Details</a></td>
                        
                      </tr>
                    
                  )))}
                  </tbody>
                  </table>
                : null }
                
              </div>
            
              
          </PanelCardWithHeading>
        ))}

            {/* Messages end */}

        {/* <PanelCardWithHeading title={localization.raisedTicketsDetails}>
          <TableSection
            data={listData}
            headers={headers}
            detailList={listData}
          />
        </PanelCardWithHeading> */}
        
            <ComplaintReply
                showFilter={showFilter}
                filterToggle={filterToggle}
                internalStatus={internalStatus}
                applyFilter={(val) => applyFilter(val)}
                statusId={'1,2,3'}
                documentUploadUrlPublic={documentUploadUrlPublic}
                // listFilterData={siteFilters?.site_types ? siteFilters : null}
                // siteFilters
            />
      </Layout>


    {/* duplicate complains ids modal starts */}
      <ModalPop
        title={'Mark as duplicate'}
        show={duplicateComplainIds}
        handleModalHide={handleDuplicateModal}
      >
        <div className="text-center">
          <div className='row'>
            <div className="col-12">
              <DropDownInput
                data={complainIdsDropdown}
                label="Select Complain ID"
                required
                errorMsg={localization.requiredName}
                getIdValue={(val) => {
                  setCategoryData({
                    ...categoryData,
                    category: val.value,
                  });
                  setComplainIdValue(val.value);
                  if (val?.value !== '') {
                    handleInputValueChange("l1", val?.value);
                  }
                }}
                isStarRequired={true}
              />
            </div>
          </div>
            <br/><br/>
          <div className='row'>
            <div className='col-md-4'>
              <Button onClick={handleMarkSubmit} className="btn btn-primary">
              Mark
              </Button>
            </div>
          </div>
        </div>
      </ModalPop>
    {/* duplicate complains ids modal ends */}

        {/* Client Msg */}
      <ModalPop
        title={localization.reply}
        show={isClientMsg}
        handleModalHide={handleIsClientMsg}
      >
        <div className="text-center">
          <div className='row'>
            <div className='col-12' style={{'color' : 'red'}}>
              {errorMessage}
            </div>
              <div className="col-12">
                <TextAreaInput
                  name="message"
                  type="text"
                  rows={4}
                  className={`inline-css scrollbar-styling`}
                  label={localization.message}
                  value={replyData.message}
                  inputValue={replyData.message}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => setReplyData({ ...replyData, message: e.target.value })}
                />
              </div>
              <div className='col-12'>
                <FileUpload
                      id={"ff_attachment"}
                      accept=".pdf,.png,.jpg,.jpeg,.doc"
                      documentUploadUrl={documentUploadUrlPublic}
                      documentUrlData={documentUrlDataPublic}
                      onChange={(val) =>
                        setReplyData({ ...replyData, attachment_file: [val] })
                      }
                    >
                    <span className="btn btn-transparent">
                        {localization.attachment}
                    </span>
                </FileUpload>
              </div>
            </div>
          <br/><br/>
          <div className="form-group btn-group">
            <Button onClick={handleMsgSubmit} className="btn btn-primary">
             Send
            </Button>
          </div>
        </div>
      </ModalPop>

        {/* end CLient MSg */}


      <ModalPop
        title={localization.conf}
        show={isConfirmation}
        handleModalHide={handleIsConfirmation}
      >
        <div className="text-center">
          <h4>{localization.closeComplainConfirmation}</h4>
          <div className='row'>
            <div className='col-12' style={{'color' : 'red'}}>
              {errorMessage}
            </div>
            <div className='col-12'>
              
                <FileUpload
                      id={"ff_attachment"}
                      accept=".pdf,.png,.jpg,.jpeg,.doc,.xls,.xlsx,.csv"
                      documentUploadUrl={documentUploadUrlPublic}
                      documentUrlData={documentUrlDataPublic}
                      onChange={(val) =>
                        setCloseData({ ...closeData, attachment_file: val })
                      }
                    >
                    <span className="btn btn-transparent">
                        {localization.attachment}
                    </span>
                </FileUpload>
            </div>
            <br/><br/>
            <div className="col-12">
                <TextAreaInput
                  name="message"
                  type="text"
                  rows={4}
                  className={`inline-css scrollbar-styling`}
                  label={localization.message}
                  value={closeData.remark}
                  inputValue={closeData.remark}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => setCloseData({ ...closeData, remark: e.target.value })}
                />
            </div>
          </div>
          <div className="form-group btn-group">
            <Button
              onClick={handleIsConfirmation}
              className="btn btn-transparent"
            >
              {localization.cancel}
            </Button>
            <Button onClick={handleCloseComplain} className="btn btn-primary">
              {localization.continue}
            </Button>
          </div>
        </div>
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
      <ModalPop
        title={localization.success}
        show={isReply}
        handleModalHide={handleIsReply}
      >
        <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>
          Success
        </h5>
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleIsReply()}
          >
            Close
          </Button>
       
      </div>
      </ModalPop>
      <ModalPop
        title={localization.categoryDetails}
        show={category}
        handleModalHide={()=>setCategory(false)}
      >
        <DropDownInput
          data={categoryList}
          label="Select CX Category"
          required
          errorMsg={localization.requiredName}
          getIdValue={(val) => {
            setCategoryData({
              ...categoryData,
              category: val.value,
            });
            if(val?.value!='')handleInputValueChange("l1", val?.value);
          }}
          isStarRequired={true}
        />
        {categoryData.category != null && categoryData.category != '' &&
        <DropDownInput
          data={l1List}
          label="Select L1"
          required
          errorMsg={localization.requiredName}
          getIdValue={(val) => {
            setCategoryData({
              ...categoryData,
              l1: val.value,
            });
            if(val?.value!='')handleInputValueChange("l2", categoryData?.category, val?.value);
          }}
          isStarRequired={true}
        />}
        {categoryData.category != null && categoryData.l1 != null && categoryData.category != '' && categoryData.l1 != '' &&
        <DropDownInput
          data={l2List}
          label="Select L2"
          required
          errorMsg={localization.requiredName}
          getIdValue={(val) => {
            setCategoryData({
              ...categoryData,
              l2: val.value,
            });
            if(val?.value!='')handleInputValueChange("l3", categoryData?.category, categoryData?.l1, val?.value);
          }}
          isStarRequired={true}
        />}
        {l3List.length>0 && categoryData.category != null && categoryData.l1 !=null && categoryData.l2 != null && categoryData.category != '' && categoryData.l1 !='' && categoryData.l2 != '' &&
        <DropDownInput
          data={l3List}
          label="Select L3"
          required
          errorMsg={localization.requiredName}
          getIdValue={(val) => {
            setCategoryData({
              ...categoryData,
              l3: val.value,
            });
          }}
          isStarRequired={true}
        />}
        <div className="text-center">
        <Button
            className="btn btn-primary mb-4"
            onClick={() => handleSaveCategory()}
          >
            {localization.save}
          </Button>
       
      </div>
      </ModalPop>
      <ModalPop
            title={localization.conf}
            show={isModal}
            handleModalHide={() => {window.location.reload(true);setIsModal(false)}}
            keyboard
            backdrop>
          <div className="text-center">
            <div className="success">
                <img src={Images?.tick} alt="" />
            </div>
            <h5>Category saved successfully</h5>
          </div>
        </ModalPop>


      
        <ModalPop
          title={localization.duplicateTicket}
          show={duplicate}
          handleModalHide={handleDuplicate}
        >
            <div className="text-center">
              <div className="">
                <img style={{'width':'15%'}} src={Images?.ErrorImg} alt="" />
              </div>
              <h5>
               Ticket ID {ticketData?.duplicate_complain_id} is already open under the same category
              </h5>
              {/* {editTicket ?
              <>
              <h6>{ticketData?.complain_description}</h6>
              <TextAreaInput
                  name="message"
                  type="text"
                  rows={4}
                  className={`inline-css scrollbar-styling`}
                  label={localization.description}
                  value={editData}
                  inputValue={editData}
                  required={true}
                  isStarRequired={true}
                  errorMsg={localization.isRequired}
                  handleChange={(e) => setEditData(e.target.value)}
                />
              
              <Button className="btn btn-theme mb-4" onClick={() => handleEditTicket()}>
                  Back
                </Button>
                  &nbsp;
                <Button className="btn btn-theme mb-4">
                  Update
                </Button>
              </>
              :
              <>
                <Button className="btn btn-theme mb-4" onClick={() => handleEditTicket()}>
                  Edit in ticket {ticketData?.duplicate_complain_id}
                </Button>
                  &nbsp;
                <Button className="btn btn-theme mb-4">
                  Create a new ticket
                </Button>
              </>
              } */}
             
              {/* <Button
                  className="btn btn-primary mb-4"
                  onClick={() => handleIsReply()}
                >
                  Close
              </Button> */}
          
          </div>
        </ModalPop>

      <ModalPop
        title={localization.conf}
        show={markSucessModal}
        handleModalHide={handleMarkModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{'Ticket Closed Sucessfully'}</h5>
          <Link
            to={`${baseUrl}/complains-list`}
            className="btn btn-primary mb-4"
          >
            {localization.goBack}{' '}
            <img src={Images?.ArrowRight} alt="" />
          </Link>
        </div>
      </ModalPop>
      <ModalPop
        title="Update Insights Category"
        show={IsEditModal}
        handleModalHide={handleEditModalHide}
        keyboard
        backdrop
      >
        <div className="row">
          <div className="col-sm-6">
            <DropDownInput
              label={localization.category}
              data={ComplaincategoryList} 
              required
              isStarRequired={true}
              errorMsg={"Category is required!"}
              getIdValue={(val) => {
                setFormData({
                  ...formData,
                  category: val.id,
                  subcategory: "",
                });
                setSubcategory([]); 
              }}
            />

          </div>
          <div className="col-sm-6">
          <DropDownInput
            label={localization.question}
            data={subcategory}
            required
            isStarRequired={true}
            errorMsg={"Question is required!"}
            getIdValue={(val) =>
              setFormData({ ...formData, subcategory: val.id })
            }
          />
          </div>      
          <div className="col-md-4 d-flex">
          <Button
            className="btn btn-primary"
            onClick={handleUpdate}
            disabled={!formData.category || !formData.subcategory}
          >
            Update
          </Button>
        </div>
        </div>
      </ModalPop>
    </Fragment>
  );
};
ViewComplain.propTypes = {
  fetchComplainList: propTypes.func,
};
export default ViewComplain;